import React from 'react';

export const DeliveryMethodIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="24" viewBox="0 0 22 24" fill="none">
    <path
      d="M14.7942 4.76953L10.9653 8.53909L14.497 12.0159V16.3549H7.43335V20.9996H19.9305V9.82593L14.7942 4.76953Z"
      fill="#BF8900"
    />
    <path
      d="M10.9654 1L2 9.82596V20.9996H7.43361V16.355V12.0159L10.9654 8.53898L14.7943 4.76956L10.9654 1Z"
      fill="#FDC300"
    />
    <path d="M10.9652 8.53909L14.7942 4.76953L11.6745 9.23722L10.9652 8.53909Z" fill="#815F00" />
    <path d="M7.43335 16.3557V21.0004L8.44849 16.3557H7.43335Z" fill="#815F00" />
  </svg>
);
